/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type FlowStatePoller_flowState = {
    readonly id: string;
    readonly flowKey: string | null;
    readonly previousState: string | null;
    readonly current: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
    } | null;
    readonly pending: {
        readonly state: string | null;
        readonly percentComplete: number | null;
        readonly errorMessage: string | null;
    } | null;
    readonly " $refType": "FlowStatePoller_flowState";
};
export type FlowStatePoller_flowState$data = FlowStatePoller_flowState;
export type FlowStatePoller_flowState$key = {
    readonly " $data"?: FlowStatePoller_flowState$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"FlowStatePoller_flowState">;
};



const node: ReaderFragment = (function () {
    var v0 = [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "percentComplete",
            "storageKey": null
        } as any,
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errorMessage",
            "storageKey": null
        } as any
    ];
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "FlowStatePoller_flowState",
        "selections": [
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "flowKey",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previousState",
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            },
            {
                "alias": null,
                "args": null,
                "concreteType": "FlowStatus",
                "kind": "LinkedField",
                "name": "pending",
                "plural": false,
                "selections": (v0 /*: any*/),
                "storageKey": null
            }
        ],
        "type": "FlowState",
        "abstractKey": null
    } as any;
})();
(node as any).hash = '26b16339e21dea2d6e6194e3ccabad79';
export default node;
